import {
  HStack,
  Icon,
  SkeletonText,
  StackProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import { RiDeleteBin2Line, RiMapPin2Line } from "@remixicon/react";
import { lazy, Suspense } from "react";
import { ProductInterface } from "../../constants/Product";
import { explodeString } from "../../utils/helperFunction";
import { DeleteProductButton } from "../button/DeleteProductButton";
import { ListProductVariant } from "../card/ListProductVariant";
import { ReadMore } from "../card/ReadMore";
import { CardSkeleton } from "../skeleton/CardSkeleton";

const ImageSliderProduct = lazy(() => import("../ImageSliderProduct"));

interface Props extends StackProps {
  data: ProductInterface | undefined;
  loaded: boolean;
}

export const MyStoreProductInfo = ({ data, loaded, ...rest }: Props) => {
  return (
    <VStack className="product" w={"100%"} align={"stretch"} {...rest}>
      {data && (
        <Suspense fallback={<CardSkeleton row={1} height={350} />}>
          <ImageSliderProduct data={data?.images as string[]} />
        </Suspense>
      )}

      <SkeletonText isLoaded={loaded} noOfLines={loaded ? undefined : 1}>
        <Text textStyle={"h-title"} mt={4}>
          {data?.name}
        </Text>
      </SkeletonText>

      <SkeletonText isLoaded={loaded} noOfLines={loaded ? undefined : 1}>
        <Text fontSize={[30, null, 32]} fontWeight={"bold"} color={"red.400"}>
          {data?.price}
        </Text>
      </SkeletonText>

      <Text textStyle={"b-reg-sb"}>Macam Varian</Text>

      {!loaded ? (
        data && <CardSkeleton row={3} height={80} />
      ) : (
        <ListProductVariant data={data?.variants} productId={data?.id} />
      )}

      <Text textStyle={"b-reg-sb"} mt={4}>
        Detail Produk
      </Text>

      <HStack>
        <Text textStyle={"b-reg"} variant={"secondary"}>
          Kategori
        </Text>

        <SkeletonText isLoaded={loaded} noOfLines={loaded ? undefined : 1}>
          <Text textStyle={"b-reg"}>{data?.category}</Text>
        </SkeletonText>
      </HStack>

      {!loaded ? (
        <SkeletonText isLoaded={loaded} noOfLines={loaded ? undefined : 4} />
      ) : (
        <ReadMore data={data?.description} />
      )}

      <Text textStyle={"b-reg-sb"} mt={4}>
        Pengiriman
      </Text>

      <HStack gap={0}>
        <Icon as={RiMapPin2Line} />

        <Text textStyle={"b-reg"} ml={2}>
          Dikirim Dari
        </Text>

        <SkeletonText
          isLoaded={loaded}
          noOfLines={loaded ? undefined : 1}
          ml={loaded ? undefined : 1.5}
        >
          <Text textStyle={"b-reg-sb"} ml={1.5}>
            {explodeString(data?.shippingCity).nama}
          </Text>
        </SkeletonText>
      </HStack>

      <DeleteProductButton
        endpoint={`/v1/reseller/product/${data?.id}`}
        title="Hapus produk dari store saya"
        mt={4}
        pageType={2}
        leftIcon={<Icon as={RiDeleteBin2Line} />}
        isDisabled={loaded ? false : true}
      />
    </VStack>
  );
};
